import React, { useMemo } from "react";
import { motion } from "framer-motion";
import { splitPeriod } from "../lib/period";

export default function Timeline({ roles }) {
  const items = useMemo(() => (Array.isArray(roles) ? roles : []), [roles]);

  return (
    <ol className="relative ml-3 pl-6 border-l border-slate-300 dark:border-slate-700">
      {items.map((job, i) => {
        const { dateText, location } = splitPeriod(job.period);
        return (
          <motion.li
            key={`${job.company}-${job.title}-${i}`}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.05 }}
            className="relative pb-8"
          >
            <span className="absolute -left-[1.1rem] top-3 h-3 w-3 rounded-full bg-[#1E3A8A] dark:bg-[#A7C7E7] ring-4 ring-white dark:ring-slate-900" />

            {dateText && (
              <div className="mb-2 pl-2">
                <span className="inline-block text-xs font-medium bg-slate-50 dark:bg-slate-900 text-slate-700 dark:text-slate-200 ring-1 ring-slate-200/70 dark:ring-slate-700 rounded px-2 py-0.5">
                  {dateText}
                </span>
              </div>
            )}

            <article className="rounded-xl bg-slate-50 dark:bg-slate-900 shadow-sm ring-1 ring-slate-200/70 dark:ring-slate-700 overflow-hidden">
              <div className="w-full bg-[#E5E7EB] dark:bg-slate-800 px-5 py-2 flex flex-col md:flex-row md:items-baseline md:justify-between gap-1">
                <h3 className="font-semibold text-[#1E3A8A] dark:text-[#A7C7E7] text-[16px]">
                  {job.title} — {job.company}
                </h3>
              </div>
              <div className="p-5">
                {location && (
                  <div className="mb-3 text-xs">
                    <span className="inline-block rounded-full px-2 py-1 bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 ring-1 ring-slate-200/70 dark:ring-slate-700">
                      {location}
                    </span>
                  </div>
                )}
                <ul className="list-disc pl-6 space-y-1 text-[15px] leading-7">
                  {job.bullets.map((b, bi) => (
                    <li key={bi}>{b}</li>
                  ))}
                </ul>
              </div>
            </article>
          </motion.li>
        );
      })}
    </ol>
  );
}
